class BundleBuilder extends HTMLElement {
  constructor() {
    super();
    this.confirmBtns = this.querySelectorAll('.bundle-builder__confirm');
    this.addToCartBtn = this.querySelector('.bundle-builder-add-to-cart');
    this.addRow = this.querySelector('.bundle-builder__add-row');
    this.removeIcons = this.querySelectorAll('.icon-remove');
    this.mainRowsContainer = this.querySelector('.bundle-builder__rows');
    this.moreRowsContainer = this.querySelector('.bundle-builder__more-rows');
    this.addRowsIndexEl = this.addRow?.querySelector('.add-row__title-index');
    this.savingsMessage = this.querySelector('.bundle-builder__savings-message');
    this.styleIcons = this.querySelectorAll('.style-icon');
    this.multiTiresBtns = this.querySelectorAll('.multi-tires__btn');

    this.confirmBtns.forEach(btn => {
      btn.addEventListener('click', this.onConfirmBtnClick.bind(this));
    })
    this.addToCartBtn.addEventListener('click', this.onAddToCartBtnClick.bind(this));
    this.addRow?.addEventListener('click', this.onAddRowClick.bind(this));
    this.removeIcons.forEach(icon => {
      icon.addEventListener('click', this.onRemoveIconClick.bind(this));
    })
    this.styleIcons.forEach(icon => {
      icon.addEventListener('click', this.onStyleIconClick.bind(this));
    })
    this.multiTiresBtns.forEach(btn => {
      btn.addEventListener('click', this.onMultiTiresBtnClick.bind(this));
    })
    document.addEventListener('DOMContentLoaded', this.singlesAndPacksSavings.bind(this));
    document.addEventListener('DOMContentLoaded', this.initialPackPrice.bind(this));
  }

  onConfirmBtnClick(e) {
    const btn = e.target;
    const thisStep = btn.closest('.bundle-builder-step');
    const thisRow = btn.closest('.bundle-builder-row');
    const thisRowIndex = parseInt(thisRow.dataset.index);
    const nextRow = thisRow.closest('.bundle-builder__rows')
                    .querySelector(`.bundle-builder-row[data-index="${thisRowIndex + 1}"]`);

    // Update selected counter
    if (thisStep) {
      const counterEl = thisStep.querySelector(".selected-counter");
      const rowIndex = thisRow.dataset.index;
      
      if (Number(counterEl.textContent) < Number(rowIndex)) {
        counterEl.textContent = rowIndex;
      }
    }

    if (nextRow) {
      // 1. Close the current row
      thisRow.classList.remove('to-select');
      thisRow.header.click();

      // 2. Open the next row
      nextRow.classList.remove('disabled');
      nextRow.classList.add('to-select');
      nextRow.header.click();
    } else {
      if (thisStep) {
        const nextStep = thisStep.nextElementSibling;

        if (nextStep) {
          // 1. Close the current step
          thisStep.classList.remove('to-select');
          thisStep.header.click();

          // 2. Close the current row
          thisRow.classList.remove('to-select');
          thisRow.header.click();

          // 3. Open the next step
          nextStep.classList.remove('disabled');
          nextStep.classList.add('to-select');
          nextStep.header.click();
  
        } else {
          this.onLastConfirmBtnClick(e);
        }
      } else {
        this.onLastConfirmBtnClick(e);
      }
    }
  }

  onLastConfirmBtnClick(e) {
    const thisRow = e.target.closest('.bundle-builder-row');
    const thisStep = e.target.closest('.bundle-builder-step');

    // 1. Close the current row
    thisRow.classList.remove('to-select');
    thisRow.header.click();

    // 2. Close the current step 
    if (thisStep) {
      thisStep.classList.remove('to-select');
      thisStep.header.click();
    }

    // 3. Activate add to cart button
    this.addToCartBtn.innerHTML = 'Add to cart';
    this.addToCartBtn.classList.remove('disabled');
  }

  onAddToCartBtnClick(e) {
    const btn = e.target;

    if (btn.classList.contains('disabled')) {
      this.highlightToSelectRow();
      this.highlightToSelectStep();
    } else {
      const forms = this.querySelectorAll("form#product-form");
      const variantItemList = {};
  
      forms.forEach((form) => {
        // Skip disabled rows
        const isDisabled = form.closest('.bundle-builder-row').classList.contains('disabled');
        if (isDisabled) return;

        // Skip hidden styles
        const styleForm = form.closest('.style-form');
        if (styleForm && styleForm.classList.contains('hidden')) return;
        
        const variantId = form.querySelector(".product-form__variant-id").value;
        
        if (variantItemList[variantId]) {
          variantItemList[variantId] = variantItemList[variantId] + 1;
        } else {
          variantItemList[variantId] = 1;
        }
      });
      
      const items = [];
      
      Object.keys(variantItemList).forEach((variantId, index) => {
        const quantity = variantItemList[variantId];
        const preorderLineItemProperty =
          document.querySelector(`.preorder__line-item-property input.variant--${variantId}`) ?
          document.querySelector(`.preorder__line-item-property input.variant--${variantId}`).value.trim() : false;
        const finalSaleLineItemProperty =
          document.querySelector(`.last-chance__line-item-property input.variant--${variantId}`) ?
          document.querySelector(`.last-chance__line-item-property input.variant--${variantId}`).value.trim() : false;
        const customLineItemPropertyEl = document.querySelector(`.custom-line-item-property input.variant--${variantId}`);
        const customLineItemPropertyTitle = customLineItemPropertyEl?.dataset.title;
        const customLineItemPropertyValue = customLineItemPropertyEl?.value.trim();
        
        items.push({
          quantity,
          id: variantId,
          properties: {}
        })
        
        if (preorderLineItemProperty) {
          items[index].properties["_Pre-order"] = preorderLineItemProperty;
        }
        
        if (finalSaleLineItemProperty) {
          items[index].properties["_LPROP"] = finalSaleLineItemProperty;
        }
        
        if (customLineItemPropertyEl) {
          items[index].properties[customLineItemPropertyTitle] = customLineItemPropertyValue;
        }
      });
  
      this.bundleBuilderATC(items);
    }
  }

  highlightToSelectRow() {
    const toSelectRow = document.querySelector('.bundle-builder-row.to-select');

    toSelectRow.classList.add('highlight-to-select');
    setTimeout(() => toSelectRow.classList.remove('highlight-to-select'), 1000);
  }

  highlightToSelectStep(){
    const toSelectStep = document.querySelector('.bundle-builder-step.to-select');
    if (!toSelectStep) return;

    toSelectStep.classList.add('highlight-to-select');
    setTimeout(() => toSelectStep.classList.remove('highlight-to-select'), 1000);
  }

  bundleBuilderATC(items) {
    const cart = document.querySelector("cart-drawer");
    const cartCounterIcon = document.querySelector(".header__icon--cart-wrapper");
  
    // Add loading animation
    this.addToCartBtn.classList.add('loading');
    cartCounterIcon.classList.add('loading');
  
    let formData = {};
  
    if (cart) {
      formData["sections"] = cart.getSectionsToRender().map((section) => section.id);
      formData["sections_url"] = window.location.pathname;
      formData["items"] = items;
      cart.setActiveElement(document.activeElement);
    }
  
    fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
    .then((response) => response.json())
    .then((response) => {
      cart.renderContents(response);
      cart.openCloseCart();
    })
    .catch((error) => {
      console.error("Error:", error);
    })
    .finally(() => {
      if (cart && cart.classList.contains("is-empty")) {
        cart.classList.remove("is-empty");
      }

      // Remove loading animation
      this.addToCartBtn.classList.remove('loading');
      cartCounterIcon.classList.remove('loading');
    });
  }

  onAddRowClick() {
    const addRowsIndexNumber = parseInt(this.addRowsIndexEl.textContent);
    const toAddRowOuter = this.moreRowsContainer.firstElementChild;
    if (!toAddRowOuter) return;
    const toAddRow = toAddRowOuter.querySelector('.bundle-builder-row')
    const toSelectRow = document.querySelector('.bundle-builder-row.to-select');
    
    // 1. If there's no to-select row, make this new row to-select and disable ATC button
    if (!toSelectRow) {
      toAddRow.classList.remove('disabled');
      toAddRow.classList.add('to-select');
      this.addToCartBtn.classList.add('disabled');
    }

    // 2. Move the new row to the main rows container
    this.mainRowsContainer.insertAdjacentElement('beforeend', toAddRowOuter);

    // 3. Show/hide remove icon
    this.showHideRemoveIcons();

    // 4. Display the new row
    toAddRowOuter.classList.remove('hidden');

    // 5. Increment the add row index 
    this.addRowsIndexEl.textContent = addRowsIndexNumber + 1;

    // 6. Hide add row element if there are no more rows
    if (!this.moreRowsContainer.firstElementChild) this.addRow.classList.add('hidden');

    // 7. Update multi-tires buttons
    this.updateMultiTiresBtns();

    // 8. Re-calc the savings
    this.calcSavings();

    // 9. Update pack price
    this.updatePackPrice();
  }

  showHideRemoveIcons() {
    const addedRows = this.mainRowsContainer.querySelectorAll('.bundle-builder-row__outer');
    if (addedRows.length === 0) return;
    addedRows.forEach(row => row.classList.remove('show-remove-icon'));
    addedRows[addedRows.length - 1].classList.add('show-remove-icon');
  }

  onRemoveIconClick(e) {
    const addRowsIndexNumber = parseInt(this.addRowsIndexEl.textContent);
    const toRemoveRowOuter = e.target.closest('.bundle-builder-row__outer');
    const toRemoveRow = toRemoveRowOuter.querySelector('.bundle-builder-row');
    const selectedVariantEl = toRemoveRow.querySelector('.bundle-builder-row__selected-variant');

    // 1. Move the row from the main rows container to the more rows container
    this.moreRowsContainer.insertAdjacentElement('afterbegin', toRemoveRowOuter);

    // 2. Hide and disable it
    toRemoveRowOuter.classList.add('hidden');
    toRemoveRow.classList.remove('to-select');
    toRemoveRow.classList.add('disabled');
    selectedVariantEl.textContent = '';

    // 3. Update add row index and show it
    this.addRowsIndexEl.textContent = addRowsIndexNumber - 1;
    this.addRow.classList.remove('hidden');

    // 4. Show/hide remove icon
    this.showHideRemoveIcons();

    // 5. Check to-select row
    const toSelectRow = document.querySelector('.bundle-builder-row.to-select');
    if (!toSelectRow) {
      this.addToCartBtn.innerHTML = 'Add to cart';
      this.addToCartBtn.classList.remove('disabled');
    }

    // 7. Update multi-tires buttons
    this.updateMultiTiresBtns();

    // 8. Re-calc the savings
    this.calcSavings();

    // 9. Update pack price
    this.updatePackPrice();
  }

  calcSavings() {
    const numberOfItems = this.mainRowsContainer.childElementCount;
    const productPriceOriginal = this.savingsMessage.dataset.productPriceOriginal;
    let productPriceDiscount;

    if (this.multiTiresBtns.length > 0) {
      this.multiTiresBtns.forEach(btn => {
        if (btn.classList.contains('active')) {
          const btnItems = parseInt(btn.dataset.items);
          const btnPricePerItem = parseInt(btn.dataset.pricePerItem);

          productPriceDiscount = btnPricePerItem;
        }
      })
    } else {
      productPriceDiscount = this.savingsMessage.dataset.productPriceDiscount;
    }

    const total = productPriceDiscount * numberOfItems;
    const totalMoney = Shopify.formatMoney(total);
    const savings = (productPriceOriginal * numberOfItems) - total;
    const savingsMoney = Shopify.formatMoney(savings);
    const totalEl = this.savingsMessage.querySelector('.total');
    const savingsEl = this.savingsMessage.querySelector('.savings');

    totalEl.textContent = totalMoney;
    if (savingsEl) savingsEl.textContent = savingsMoney;
  }

  onStyleIconClick(e) {
    const styleIcon = e.target.closest('.style-icon');
    const thisRow = styleIcon.closest('.bundle-builder-row');
    const allForms = thisRow.querySelectorAll('.style-form');
    const relatedForm = thisRow.querySelector(styleIcon.dataset.form);
    const variantRadiosEl = relatedForm.querySelector('variant-radios');

    // stopImmediatePropagation
    const input = styleIcon.querySelector('input[type="radio"]');
    input.addEventListener('click', function (e) {
      e.stopImmediatePropagation();
    })

    // 1. Show related form
    allForms.forEach((form) => form.classList.add('hidden'));
    relatedForm.classList.remove('hidden');

    // 2. Upate info
    variantRadiosEl.getSelectedOptions();
    variantRadiosEl.getVariantJSON();
    variantRadiosEl.getSelectedVariant();
    variantRadiosEl.updateProductInfo();
    variantRadiosEl.updateBundleBuilder();
  }

  onMultiTiresBtnClick(e) {
    const btn = e.target;
    const requiredNumberOfRows = parseInt(btn.dataset.items);
    const currentNumberOfRows = this.mainRowsContainer.childElementCount;

    if (requiredNumberOfRows > currentNumberOfRows) {
      const difference = requiredNumberOfRows - currentNumberOfRows;

      // active class
      this.multiTiresBtns.forEach(el => el.classList.remove('active'));
      btn.classList.add('active');

      // Add rows
      for (let index = 0; index < difference; index++) {
        this.addRow.click();
      }

    } else if (requiredNumberOfRows < currentNumberOfRows) {
      const difference = currentNumberOfRows - requiredNumberOfRows;

      // active class
      this.multiTiresBtns.forEach(el => el.classList.remove('active'));
      btn.classList.add('active');

      // Remove rows
      for (let index = 0; index < difference; index++) {
        const removeIconsInTheMainRowsContainer = this.mainRowsContainer.querySelectorAll('.icon-remove');
        const lastRemoveIcon = removeIconsInTheMainRowsContainer[removeIconsInTheMainRowsContainer.length - 1];
        
        lastRemoveIcon.click();
      }
    }
  }

  updateMultiTiresBtns() {
    if (this.multiTiresBtns.length === 0) return;
    const currentNumberOfRows = this.mainRowsContainer.childElementCount;

    this.multiTiresBtns.forEach(btn => {
      const btnItems = parseInt(btn.dataset.items);

      if (currentNumberOfRows >= btnItems) {
        this.multiTiresBtns.forEach(el => el.classList.remove('active'));
        btn.classList.add('active');
      }
    })
  }

  singlesAndPacksSavings() {
    const holderEl = document.querySelector('.singles-and-packs__savings-holder');
    if (!holderEl) return;
    const savingsEls = document.querySelectorAll('.singles-and-packs__savings');

    holderEl.textContent = this.savingsMessage.dataset.singlesAndPacksSavings;
    savingsEls.forEach(el => el.textContent = holderEl.textContent);
  }

  initialPackPrice() {
    const packPrice = document.querySelectorAll('.pack-price');
    if (!packPrice.length > 0) return;
    const initialPackPrice = this.savingsMessage.querySelector('.total');

    packPrice.forEach(price => price.textContent = initialPackPrice.textContent);
  }

  updatePackPrice() {
    const singlePrice = document.querySelectorAll('.product-price');
    const packPrice = document.querySelectorAll('.pack-price');
    const currentPackPrice = this.savingsMessage.querySelector('.total');
    const savingsLabel = document.querySelectorAll('.product-price__saving-label');
    const currentSavings = this.savingsMessage.querySelector('.savings');

    // 1. Pack price
    packPrice.forEach(price => price.textContent = currentPackPrice.textContent);
    singlePrice.forEach(price => price.classList.add('hidden'));
    packPrice.forEach(price => price.classList.remove('hidden'));

    // 2. Savings label
    if (savingsLabel.length > 0) {
      savingsLabel.forEach(label => {
        if (currentSavings) {
          label.textContent = `Save ${currentSavings.textContent}`;
        } else {
          label.classList.add('hidden');
        }
      });
    }
  }
}

customElements.define('bundle-builder', BundleBuilder)

class BundleBuilderRow extends HTMLElement {
  constructor() {
    super();
    this.header = this.querySelector('.bundle-builder-row__header');
    this.body = this.querySelector('.bundle-builder__body');

    this.header.addEventListener('click', this.onHeaderClick.bind(this));
    window.addEventListener('resize', this.heightAnimation.bind(this));
  }

  onHeaderClick() {
    if (this.classList.contains('disabled')) {
      this.highlightToSelectRow();
    } else {
      const allRows = document.querySelectorAll('.bundle-builder-row');
      
      // 1. Active class
      if (this.classList.contains('active')) {
        this.classList.remove('active');
      } else {
        allRows.forEach(el => el.classList.remove('active'));
        this.classList.add('active');

        // 2. Update info
        this.updateRowInfo();
      }
      
      // 3. Open the row
      this.heightAnimation();
    }
  }

  heightAnimation() {
    const bodyHeight = getComputedStyle(this.querySelector('.bundle-builder__body-inner')).height;
    const allRows = document.querySelectorAll('.bundle-builder-row');

    if (this.classList.contains('active')) {
      // Close all rows
      allRows.forEach(el => el.querySelector('.bundle-builder__body').style.maxHeight = 0);

      // Open the row
      this.body.style.maxHeight = bodyHeight;
    } else {
      // Close the row
      this.body.style.maxHeight = 0;
    }
  }

  highlightToSelectRow() {
    const toSelectRow = document.querySelector('.bundle-builder-row.to-select');

    toSelectRow.classList.add('highlight-to-select');
    setTimeout(() => toSelectRow.classList.remove('highlight-to-select'), 1000);
  }

  updateRowInfo() {
    const styleForms = this.querySelector('.product-style__style-forms');
    let variantRadiosEl;
    
    if (styleForms) {
      variantRadiosEl = this.querySelector('.style-form:not(.hidden)').querySelector('variant-radios');
    } else {
      variantRadiosEl = this.querySelector('variant-radios');
    }

    variantRadiosEl.getSelectedOptions();
    variantRadiosEl.getVariantJSON();
    variantRadiosEl.getSelectedVariant();
    variantRadiosEl.updateProductInfo();
    variantRadiosEl.updateBundleBuilder();
  }
}

customElements.define('bundle-builder-row', BundleBuilderRow);

class BundelBuilderStep extends HTMLElement {
  constructor() {
    super();
    this.header = this.querySelector('.bundle-builder-step__header');
    this.body = this.querySelector('.bundle-builder-step__body');

    this.header.addEventListener('click', this.onHeaderClick.bind(this));
  }

  onHeaderClick() {
    if (this.classList.contains('disabled')) {
      this.highlightToSelectStep();
    } else {
      const allSteps = document.querySelectorAll('.bundle-builder-step');
  
      // 1. Show/hide current step
      if (this.classList.contains('active')) {
        this.classList.remove('active');
      } else {
        allSteps.forEach(el => el.classList.remove('active'));
        this.classList.add('active');
      }
    }
  }

  highlightToSelectStep(){
    const toSelectStep = document.querySelector('.bundle-builder-step.to-select');
    if (!toSelectStep) return;

    toSelectStep.classList.add('highlight-to-select');
    setTimeout(() => toSelectStep.classList.remove('highlight-to-select'), 1000);
  }
}

customElements.define('bundle-builder-step', BundelBuilderStep);